import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../components/icons/Logo';

const TermsOfService: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-8">
          <Link to="/">
            <Logo className="h-16 mx-auto" showCompanyName={false} />
          </Link>
          <h1 className="mt-6 text-3xl font-extrabold text-gray-900">Terms of Service</h1>
        </div>
        
        <div className="bg-white shadow overflow-hidden sm:rounded-lg">
          <div className="px-4 py-5 sm:p-6 prose max-w-none">
            <h2>1. Introduction</h2>
            <p>
              Welcome to YouCRM by Energia Info Kft. These Terms of Service govern your use of our CRM system
              and the services we provide. By accessing or using our services, you agree to be bound by these terms.
            </p>
            
            <h2>2. Access and Usage</h2>
            <p>
              This system contains sensitive business information and is accessible only by authorized personnel.
              Unauthorized access or use of this system is strictly prohibited.
            </p>

            <h2>3. Account Security</h2>
            <p>
              You are responsible for maintaining the confidentiality of your account credentials.
              Any activity that occurs under your account is your responsibility.
            </p>

            <h2>4. Data Protection</h2>
            <p>
              We implement appropriate security measures to protect your data. For more information on how we handle
              your data, please refer to our <Link to="/privacy-policy" className="text-primary-600 hover:text-primary-700">Privacy Policy</Link>.
            </p>

            <h2>5. Service Availability</h2>
            <p>
              We strive to provide uninterrupted service, but we cannot guarantee that the service will be available at all times.
              We reserve the right to suspend or terminate the service for maintenance or other reasons.
            </p>

            <h2>6. Limitations of Liability</h2>
            <p>
              Energia Info Kft. shall not be liable for any indirect, incidental, special, consequential, or punitive damages
              resulting from your use of or inability to use the service.
            </p>

            <div className="mt-8 text-center">
              <Link to="/login" className="text-primary-600 hover:text-primary-700">
                Return to Login
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService; 